<template>
  <div ref="wrapper" :class="bemBlock">
    <ul ref="list" v-drag-scroll :class="bemElement('list')">
      <li
        v-for="(category, index) in siblingMenu"
        :key="index"
        :class="bemElement('item')"
      >
        <BaseLink
          :class="[
            bemElement('link'),
            { 'router-link-active': isSelected(category) },
          ]"
          :url="category.url"
          @click="handleClick(category)"
        >
          {{ category.name }}
        </BaseLink>
      </li>
    </ul>
  </div>
</template>

<script>
import { types } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';
import BaseLink from './BaseLink.vue';
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';

const analyticsEventBus = getAnalyticsEventBus();

export default {
  name: 'TheProductListSiblingMenu',

  components: { BaseLink },

  mixins: [bemClassesMixin],

  props: {
    siblingMenu: {
      type: Array,
      default() {
        return [];
      },
    },
    currentCategory: {
      type: Object,
      default: null,
    },
    isViewAllView: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.scrollToSelectedCategory();
    });
  },

  methods: {
    /**
     * A view all entry shares its id with the category it belongs to, so the
     * view being displayed has to match too: the view all is only selected
     * while looking at the view all, and the category only while looking at
     * the category.
     * @param {Object} category - sibling menu entry
     * @returns {boolean} true when the entry is the one being displayed
     */
    isSelected(category) {
      if (!this.currentCategory || this.currentCategory.id !== category.id) {
        return false;
      }
      return !!category.isViewAll === this.isViewAllView;
    },
    /**
     * A view all entry points at the same url as its category, so the view
     * being opened is recorded here. Any other entry clears it.
     * @param {Object} category - sibling menu entry
     * @returns {void}
     */
    handleClick(category) {
      this.$store.commit(
        types.productList.setViewAllCategoryId,
        category.isViewAll ? category.id : null
      );
      this.emitAnalyticsEvent(category);
    },
    emitAnalyticsEvent(category) {
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.productListCategoryFilterClicked,
        {
          categoryName: category.name,
        }
      );
    },
    scrollToSelectedCategory() {
      const target = this.$refs.list;
      const selected = target?.querySelector('.router-link-active');
      if (!selected) return;
      const baseOverflowing =
        parseFloat(
          window
            .getComputedStyle(target)
            .getPropertyValue('--list-sibling-menu-base-overflowing')
        ) || 40;
      const position =
        selected.offsetLeft +
        selected.offsetWidth +
        baseOverflowing -
        target.offsetWidth;
      if (position <= 0) return;
      target.scrollLeft = position;
    },
  },
};
</script>
